import React from "react";
import { Wrapper } from "../../Wrapper";
import styles from "../styles/TextInAColouredPanelWidget.module.scss";

export const TextInAColouredPanel = ({ data }: any) => {
  return (
    <Wrapper>
      <section className={styles.section}>
        <h3 className={styles.title}>{data.title}</h3>
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: data.body }}
        />
        <a
          className={styles.link}
          href={data.link}
          target="_blank"
          rel="noopener noreferrer"
          title="View website (new tab)"
        >
          {data.link_label}
        </a>
      </section>
    </Wrapper>
  );
};
